var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#828292",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9375 17.3996C6.9375 17.0682 7.20613 16.7996 7.5375 16.7996H13.4251C13.7565 16.7996 14.0251 17.0682 14.0251 17.3996C14.0251 17.7309 13.7565 17.9996 13.4251 17.9996H7.5375C7.20613 17.9996 6.9375 17.7309 6.9375 17.3996ZM6.9375 12.5998C6.9375 12.2684 7.20613 11.9998 7.5375 11.9998H16.4626C16.794 11.9998 17.0626 12.2684 17.0626 12.5998C17.0626 12.9311 16.794 13.1998 16.4626 13.1998H7.5375C7.20613 13.1998 6.9375 12.9311 6.9375 12.5998ZM6.9375 7.79995C6.9375 7.46858 7.20613 7.19995 7.5375 7.19995H16.4626C16.794 7.19995 17.0626 7.46858 17.0626 7.79995C17.0626 8.13132 16.794 8.39995 16.4626 8.39995H7.5375C7.20613 8.39995 6.9375 8.13132 6.9375 7.79995ZM19 2.4H14.82C14.4 1.008 13.3 0 12 0C10.7 0 9.6 1.008 9.18 2.4H5C4.86 2.4 4.73 2.412 4.6 2.448C4.21 2.544 3.86 2.784 3.59 3.108C3.41 3.324 3.26 3.588 3.16 3.876C3.06 4.152 3 4.464 3 4.8V21.6C3 21.924 3.06 22.248 3.16 22.536C3.26 22.824 3.41 23.076 3.59 23.304C3.86 23.628 4.21 23.868 4.6 23.964C4.73 23.988 4.86 24 5 24H19C20.1 24 21 22.92 21 21.6V4.8C21 3.48 20.1 2.4 19 2.4ZM19 21.0091C19 21.5564 18.5564 22 18.0091 22H5.99091C5.44364 22 5 21.5564 5 21.0091V4.99091C5 4.44365 5.44364 4 5.99091 4H18.0091C18.5564 4 19 4.44364 19 4.99091V21.0091Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaso);
export default __webpack_public_path__ + "static/media/Caso.07d3f5f0.svg";
export { ForwardRef as ReactComponent };